import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  standalone: true,
  name: 'formattedDateTime',
})
export class FormattedDateTimePipe implements PipeTransform {
  private readonly datePipe = new DatePipe('en-US');

  transform(
    value?: Date | string | number | null,
    withSeconds: boolean = false
  ): string {
    if (!value) return '-';

    const format = withSeconds ? 'MM/dd/yyyy hh:mm:ss a' : 'MM/dd/yyyy hh:mm a';
    const date = new Date(value);
    return isNaN(date.getTime())
      ? '-'
      : this.datePipe.transform(date, format) ?? '-';
  }
}
